__webpack_require__.p = "https://www.coop.co.uk/blog/";